import * as Types from '@/types/schema';

import gql from 'graphql-tag';
import * as Urql from '@/utils/urql';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type LearnerManagerQueryVariables = Types.Exact<{
  filters: Types.UserFilters;
}>;


export type LearnerManagerQuery = { user?: { managerId?: string | null } | null };


export const LearnerManagerDocument = /*#__PURE__*/ gql`
    query learnerManager($filters: UserFilters!) {
  user(filters: $filters) {
    managerId
  }
}
    `;

export function useLearnerManagerQuery(options: Omit<Urql.UseQueryArgs<LearnerManagerQueryVariables>, 'query'>) {
  return Urql.useQuery<LearnerManagerQuery, LearnerManagerQueryVariables>({ query: LearnerManagerDocument, ...options });
};